<template>
    <div id="loyaltyComponent">
        <div class="loyaltyComponent-inner">
            <div class="wz-row">
                <template v-if="user_id">
                    <div class="tabs" v-bind:class="{loading:loading}">
                        <div class="header-tab">
                            <ul>
                                <li class="tab-item" v-bind:class="{active:tab === 1}" @click="tab=1">Thông tin cá nhân</li>
                                <li class="tab-item" v-bind:class="{active:tab === 2}" @click="tab=2">Hạng thẻ thành viên</li>
                                <li class="tab-item" v-bind:class="{active:tab === 3}" @click="tab=3">Số điểm tích lũy</li>
                                <li class="tab-item" v-bind:class="{active:tab === 4}" @click="tab=4">Lịch sử giao dịch</li>
                            </ul>
                        </div>
                        <div class="content-tab">
                            <div id="profileInfo" class="tab-content" v-bind:class="{active:tab === 1}">
                                <h3 class="tab-content-title">Thông tin cá nhân</h3>
                                <form action=""  v-on:submit.prevent="updateMembership">
                                    <div class="field">
                                        <label for="name">Họ tên</label>
                                        <input type="text" id="name" v-model="membership.name">
                                    </div>
                                    <div class="field">
                                        <label for="phone">Số điện thoại</label>
                                        <input type="text" id="phone" :value="membership.phone_number" disabled>
                                    </div>
                                    <div class="field" v-if="!disableBirthday">
                                        <label for="birthday">Ngày sinh</label>
                                        <datetime type="date" id="birthday" format="dd/MM/yyyy" class="form-control"  v-model="membership.birthday" autocomplete="off"></datetime>
                                    </div>
                                    <div class="field" v-else>
                                      <label for="birthday">Ngày sinh</label>
                                      <input :value="$globalLib.dateFormat(new Date(this.membership.birthday),'dd/mm/yyyy')" disabled/>
                                    </div>
                                    <div class="action">
                                        <button type="submit">Cập nhật</button>
                                    </div>
                                </form>

                            </div>
                            <div id="memberCard" class="tab-content" v-bind:class="{active:tab === 2}">
                                <h3 class="tab-content-title">Hạng thẻ thành viên</h3>
                                <div class="cardinfo">
                                    <h4>Hạng thẻ thành viên của bạn</h4>
                                    <div class="cards">
                                        <div class="img">
                                            <img src="../assets/images/card.png" alt="">
                                        </div>
                                        <div class="info">
                                            <div class="cardName">{{membership.membership_type_name}}</div>
                                            <div class="carDesc">Tích lũy thêm  {{points.needpoint}} điểm nữa để trở thành Thành viên {{points.needname}}</div>
                                            <div class="carCta">Xem chi tiết tại: <a href="http://suonmuoi.com/chinh-sach-hoi-vien/">Chính sách hội viên</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="memberPoint" class="tab-content" v-bind:class="{active:tab === 3}">
                                <h3 class="tab-content-title">Số điểm tích lũy</h3>
                                <div class="tab-content-body">
                                    <p>Giờ đây khi thanh toán tại Sườn Mười đều được tặng điểm thưởng. Bạn có thể dùng điểm này để nhận những ưu đãi khi thanh toán hóa đơn tại Sườn Mười.</p>
                                    <p class="h-light">Tổng số điểm bạn đã tích lũy được: <span>{{membership.point}}</span> điểm </p>
                                    <p>Tích lũy thêm điểm để nâng hạng và nhận những ưu đãi mới nhất dành cho hạng thẻ của bạn</p>
                                    <p>Xem chi tiết tại: <a href="http://suonmuoi.com/khuyen-mai/">Khuyến mãi</a></p>
                                </div>
                            </div>
                            <div id="memberHistories" class="tab-content" v-bind:class="{active:tab === 4}">
                                <h3 class="tab-content-title">Lịch sử giao dịch</h3>
                                <div class="tab-content-body">
                                    <div class="item" v-for="(value,key) in transactionHistory">
                                        <div class="globalInfo">
                                            <div class="left">
                                                <h4>{{key + 1}}. {{value.to_address}}</h4>
                                                <p>{{value.created}}</p>
                                                <p v-if="value.payment==='vnpay'">Thanh toán qua VnPay</p>
                                                <p v-else>Thanh toán khi giao hàng</p>
                                            </div>
                                            <div>
                                                <span class="open-cta" @click="showCta(value)">Xem chi tiết <i class="fa fa-angle-down"></i></span>
                                            </div>
                                        </div>
                                        <div class="ctaInfo" v-show="value.cta">
                                            <table class="table-history">
                                                <thead>
                                                <tr>
                                                    <th>Tên sản phẩm</th>
                                                    <th>Giá tiền</th>
                                                    <th>Số lượng</th>
                                                    <th>Tổng tiền</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(item,key) in value.order_data_item">
                                                    <td>
                                                        <p class="name">{{item.Item_Name}}</p>
                                                        <p class="note">{{item.Note}}</p>
                                                    </td>
                                                    <td>{{item.Amount}}</td>
                                                    <td>{{item.Quantity}}</td>
                                                    <td>{{item.Amount * item.Quantity}}</td>
                                                </tr>
                                                <tr v-if="value.Discount_Amount">
                                                  <td data-title="Tên">
                                                    <h5 class="text-bold">Voucher</h5>
                                                  </td>
                                                  <td data-title="Giá">-{{value.Discount_Amount | formatPrice}}</td>
                                                  <td data-title="Số lượng">1</td>
                                                  <td data-title="Tổng giá"><span class="text-bold">-{{value.Discount_Amount | formatPrice}}</span></td>
                                                </tr>
                                                <tr>
                                                  <td data-title="Tên">
                                                    <h5 class="text-bold">Phí giao hàng</h5>
                                                  </td>

                                                  <td data-title="Giá">
                                                    <span v-if="value.ship_price_real">{{value.ship_price_real | formatPrice}}</span>
                                                    <span v-else> Miễn phí </span>
                                                  </td>
                                                  <td data-title="Số lượng">1</td>
                                                  <td data-title="Tổng giá">
                                                    <span class="text-bold" v-if="value.ship_price_real">{{value.ship_price_real | formatPrice}}</span>
                                                    <span class="text-bold" v-else> Miễn phí </span>
                                                  </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Profile',
        props:{
            mpoint1: {
                type: Number,
                default: 2000000
            },
            mpoint2: {
                type: Number,
                default: 200
            },
        },
        data() {
            return {
                membership: {},
                vouchers: [],
                transactionHistory: [],
                user_id: this.$foodbookConfig.user_phone,
                loading: true,
                member: {
                    birthday: null,
                    phone: null,
                    name: null,
                    gender: -1,
                },
                disableBirthday:false,
                tab:1,
                points:{
                    silver: 2000,
                    gold: 5000,
                    diamond:7000,
                    needpoint:0,
                    needname:"",

                }
            };
        },
        created() {
            if (parseInt(this.user_id)) {
                this.getMembership(this.user_id);
                this.getOrderLog(this.user_id);
            } else {
                this.$toasted.show("The system has not been processed yet. Please try again later..", {
                    position: "top-center",
                    duration: 10000,
                    type: 'error'
                });
                window.location.replace(this.$foodbookConfig.loginpage);
            }
        },
        computed: {
            outputWeb1() {
                return this.membership.payment_amount - (Math.floor( this.membership.payment_amount / this.mpoint1) * this.mpoint1);
            },
            outputWeb2() {
                return Math.floor(this.membership.point / this.mpoint2);
            }
        },
        methods: {
            //Lay thông tin khách hàng
            getMembership($phone) {
                this.$http.get(this.$foodbookConfig.wpapi + '/membership_detail', {
                    params: {
                        user_id: $phone
                    }
                }).then(response => {
                    if (!response.body.data) {
                        this.$toasted.show("The system has not been processed yet. Please try again later..", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                    } else {
                        this.membership = response.body.data;
                        if(this.membership.birthday){
                            this.disableBirthday = true;
                            this.membership.birthday = new Date(this.membership.birthday).toISOString();
                        }
                        //Point
                        if(this.membership.point < this.points.silver){
                            this.points.needpoint = this.points.silver - this.membership.point;
                            this.points.needname = "Bạc";
                        } else if(this.membership.point < this.points.gold){
                            this.points.needpoint = this.points.gold - this.membership.point;
                            this.points.needname = "Vàng";
                        }else if(this.membership.point < this.points.diamond){
                            this.points.needpoint = this.points.diamond - this.membership.point;
                            this.points.needname = "Kim cương";
                        }
                    }
                }, response => {
                    // error callback
                    console.log("Error getMembership");
                });
            },
            // Lấy danh sách đơn đặt hàng
            getOrderLog($phone) {
                this.$http.get(this.$foodbookConfig.wpapi + '/histories',{
                    params: {
                        phone: $phone
                    }
                }).then(response => {
                    if (response.body.error) {
                       /* this.$toasted.show(response.body.error.message, {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });*/
                        console.log(response.body.error.message);
                    }else{
                        this.loading = false;
                        this.transactionHistory = response.body.orders;
                    }
                }, response => {
                    console.log("Error getOrderLog");
                });
            },
            // Update membership
            updateMembership(event){
                event.preventDefault();
                this.loading = true;
                this.$http.post(this.$foodbookConfig.wpapi + '/updateMember', {
                    birthday: this.$globalLib.dateFormat(new Date(this.membership.birthday),"dd/mm/yyyy"),
                    name: this.membership.name,
                    phone: this.membership.phone_number,
                }, {method: 'POST'}).then(response => {
                    if (response.body.data === "1") {
                        this.$toasted.show("Cập nhật thành công", {
                            position: "top-center",
                            duration: 5000,
                            type: 'success'
                        });
                        this.loading = false;
                        //this.member.birthday = this.$options.filters.formatDate(this.member.birthday,false);
                    } else {
                        this.loading = false;
                        this.$toasted.show("Cập nhật không thành công. Vui lòng thử lại sau!", {
                            position: "top-center",
                            duration: 10000,
                            type: 'error'
                        });
                    }
                }, response => {
                    this.loading = false;
                    console.log('Cập nhật không thành công. Vui lòng thử lại sau!');
                });
            },

            //Cta order
            showCta(item){

                item.cta = !item.cta;
                console.log(item);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue